import * as React from 'react';

import * as style from './RealtyType.css';
import classnames from 'classnames';

type ITRealtyTypeProps = {
  types: {
    id: number;
    domId: string;
    text: string;
  }[];
  filterType: string;
  onChangeType: (newValue: string) => void;
  hasCom: boolean;
};

export const RealtyType: React.FC<ITRealtyTypeProps> = ({ types, filterType, onChangeType, hasCom = true }) => {
  return (
    <fieldset className={style['container']}>
      {types.map(({ id, domId, text }) => (
        <div
          key={id}
          onClick={() => onChangeType(domId)}
          className={classnames(
            style['filter-label'],
            domId === filterType && style['filter-label-checked'],
            hasCom && domId === 'com' && style['hiden-commercial'],
          )}
        >
          {text}
        </div>
      ))}
    </fieldset>
  );
};
